module.exports = require("@splunk/themes/scp");